import React from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";

const Documents = () => {
  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
      <div
        style={{
          width: "100%",
          //   backgroundColor: colors.secondaryDarkBlue,
          minHeight: 60,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"COMPANY REGISTRATION"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"VAT DOCUMENTS"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"TERMS AND CONDITIONS"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SERVICE AGREEMENT"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
        />
      </div>
      <div
        style={{
          flex: 1,

          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: "75%",
            minWidth: 470,
            maxWidth: 470,

            backgroundColor: colors.white,
            WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          }}
        ></div>
        <div style={{ display: "flex", width: 470, alignItems: "center" }}>
          <ImageUploadAWS
            mini={true}
            labelTitle={"UPLAOD DOCUMENT"}
            width={310}
            size={"100%"}
          />
          <div style={{ marginTop: 30, marginLeft: 10 }}>
            <BaseButtons
              label={"SAVE UPLOAD"}
              borderRadius={8}
              backgroundColor={colors.secondaryDarkBlue}
              width={120}
              height={55}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documents;
